import { receiveEmojiService } from "../services/ChatService";

const EMOJI_CACHE_KEY = "chat:emoji-catalog";
const EMOJI_CACHE_TTL_MS = 24 * 60 * 60 * 1000;
let memoryEmojiCatalog = null;
let emojiCatalogPromise = null;

export const readCachedChatEmojis = () => {
  if (Array.isArray(memoryEmojiCatalog) && memoryEmojiCatalog.length) {
    return memoryEmojiCatalog;
  }

  try {
    const rawCache = localStorage.getItem(EMOJI_CACHE_KEY);

    if (!rawCache) return [];

    const parsedCache = JSON.parse(rawCache);
    const cachedAt = Number(parsedCache?.cachedAt ?? 0);
    const data = Array.isArray(parsedCache?.data) ? parsedCache.data : [];

    if (!cachedAt || Date.now() - cachedAt > EMOJI_CACHE_TTL_MS) {
      localStorage.removeItem(EMOJI_CACHE_KEY);
      memoryEmojiCatalog = null;
      return [];
    }

    memoryEmojiCatalog = data;
    return data;
  } catch (error) {
    console.error("Error reading cached emojis:", error);
    localStorage.removeItem(EMOJI_CACHE_KEY);
    memoryEmojiCatalog = null;
    return [];
  }
};

export const writeCachedChatEmojis = (emojis = []) => {
  const safeData = Array.isArray(emojis) ? emojis : [];

  try {
    memoryEmojiCatalog = safeData;
    localStorage.setItem(
      EMOJI_CACHE_KEY,
      JSON.stringify({
        cachedAt: Date.now(),
        data: safeData,
      }),
    );
  } catch (error) {
    console.error("Error caching emojis:", error);
  }
};

export const getChatEmojiCatalog = async () => {
  const cachedEmojis = readCachedChatEmojis();

  if (cachedEmojis.length) {
    return cachedEmojis;
  }

  if (emojiCatalogPromise) {
    return emojiCatalogPromise;
  }

  emojiCatalogPromise = receiveEmojiService()
    .then((emojis) => {
      const safeEmojis = emojis || [];
      writeCachedChatEmojis(safeEmojis);
      return safeEmojis;
    })
    .finally(() => {
      emojiCatalogPromise = null;
    });

  return emojiCatalogPromise;
};

export const preloadChatEmojiCatalog = async () => {
  const cachedEmojis = readCachedChatEmojis();

  if (cachedEmojis.length) {
    return cachedEmojis;
  }

  return getChatEmojiCatalog();
};
